import React, { Component } from 'react';
import Vas from '../Vas';

class ActivateSuccess extends Component
{
    constructor(props)
    {
        super(props);
        this.state = {};
    }

    render()
    {
        return ( <div className="LoginContainer">
          <div
            className={"form"}
            style={{ width:'400px' }}>
            <table>
              <thead>
                <tr>
                  <th colSpan={2}><h2>{Vas.Resources.Labels["ActivateSuccess"]}</h2></th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                  </td>
                </tr>
              </tbody>
            </table> 
          </div>
        </div>);
    }
}
export default ActivateSuccess;
